var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlantsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(-234 -38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 24,
    height: 24,
    transform: "translate(234 38)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(132.025 -41.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M48.358,86.995a.522.522,0,0,1,.648.553c-.02.223-.042.444-.067.664a41.926,41.926,0,0,1-.961,5.409A18.08,18.08,0,0,1,46.661,97.3a6.893,6.893,0,0,1-3.2,3.053,7.008,7.008,0,0,1-3.218.783,5.044,5.044,0,0,1-2.866-.747l-.323-.181a.145.145,0,0,0-.176.021,10.365,10.365,0,0,0-1.381,1.862c-.183.288-.35.585-.539.869a.27.27,0,0,1-.217.11c-.381-.091-.759-.2-1.141-.3a.144.144,0,0,1-.082-.218A34.751,34.751,0,0,1,42.971,92.9l-.044-.058c-.121.069-.244.137-.364.209A45.207,45.207,0,0,0,37.4,96.487a9.875,9.875,0,0,0-1.828,1.8.142.142,0,0,1-.241-.015,4.852,4.852,0,0,1-.548-1.751,7.416,7.416,0,0,1,2.749-6.664A6.12,6.12,0,0,1,40.5,88.576c1.258-.23,2.088-.354,3.8-.544A22.212,22.212,0,0,0,48.358,86.995Z",
    transform: "translate(72.725 -3.397)",
    fill: "#90c337"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantsIcon);
export default __webpack_public_path__ + "static/media/plants-icon.2a5198a6b83412e9bc510b56fbff5930.svg";
export { ForwardRef as ReactComponent };